/*
 * Satış Sonrası destek kayıtları için sağ tık menüsü
 */

import { Box, Text, Flex } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function SatisSonrasiContextMenu({
  position,
  data,
  onClose,
  onResolveOnly,
  onSendSms,
  onAddNote,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 220, menuHeight: 180 });

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="180px"
      fontSize="11px"
      py={1}
    >
      <MenuItem
        label="Çözüldü Olarak İşaretle"
        onClick={() => {
          onResolveOnly?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="SMS Gönder"
        onClick={() => {
          onSendSms?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Not Ekle"
        onClick={() => {
          onAddNote?.(data);
          onClose?.();
        }}
      />
    </Box>
  );
}

function MenuItem({ label, onClick }) {
  return (
    <Flex
      align="center"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{ bg: "gray.50", color: "gray.900", transform: "scale(1.02)" }}
      onClick={onClick}
    >
      <Text fontWeight="500" color="gray.600" fontSize="11px">
        {label}
      </Text>
    </Flex>
  );
}

export default SatisSonrasiContextMenu;


